import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MapService } from '../../services/map.service';
import olMap from 'ol/Map';
import {fromLonLat, toLonLat} from 'ol/proj';
import { PointsService } from '../../services/points.service';
import { NavaidFile, NavaidModel } from '../../models/navaid';
import { NavaidsService } from 'src/app/services/navaids.service';
import { GlobalSelectionControlService } from 'src/app/map/services/global-selection-control.service';
import { ToolsControlService } from 'src/app/services/tools-control.service';
import { ModalConfirmationService } from 'src/app/services/modal-confirmation.service';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { FormControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MenuManagementService } from 'src/app/menu/services/menu-management.service';
import { CoordenateService } from 'src/app/services/coordenate.service';
import { ProcedureModel } from 'src/app/models/procedure';
import { Feature } from 'ol';
import { FeatureType, NavaidStatus } from 'src/app/models/EnumTypes';
import { sectorizationGraphData } from 'src/app/models/sectorizationGraphData';
import { SectorizationDisplayComponent } from 'src/app/popup/sectorization-display/sectorization-display/sectorization-display.component';
import { Distance } from 'src/app/utils/distance';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { TabsService } from 'src/app/services/tabsService';
import { ConfigurationModel } from 'src/app/models/configuration';
import { config } from 'rxjs';
import { UtilsService } from 'src/app/services/utils.service';
import { VectorLayerDMTR } from 'src/app/menu/view-menu/layer';
import { AirSpaceBoundaryModel } from 'src/app/models/air-space-boundary';
import { VicentyToolControlService } from 'src/app/services/vicenty-tool-control.service';
import { SelectAntennaPatternService } from 'src/app/services/select-antenna-pattern.service';
import { AntennaTypes } from 'src/app/models/EnumTypes';
import { ProjectService } from 'src/app/services/project.service';


@Component({
  selector: 'app-navaids',
  templateUrl: './navaids.component.html',
  styleUrls: ['./navaids.component.scss'],
  standalone: false
})
export class NavaidsComponent implements OnInit {

  navaidController : NavaidsService;
  menuController : MenuManagementService;
  pointsController : PointsService;
  mapService : MapService;
  secondaryForm: UntypedFormGroup;
  primaryForm: UntypedFormGroup;


  colapsableLabelSectorizations:boolean = true;
  colapsableDivSectorizations:boolean = true;
  colapsableLabelActualScreeningAngle:boolean = true;
  colapsableDivActualScreeningAngle:boolean = true;
  colapsableLabelGeneralPlanning:boolean = true;
  colapsableDivGeneralPlanning:boolean = true;
  colapsableLabelProceduresList:boolean = true;
  colapsableDivProceduresList:boolean = true;
  colapsableLabelAirspaceBoundariesList:boolean = true;
  colapsableDivAirspaceBoundariesList:boolean = true;
  colapsableLabelDME_TACAN:boolean = true;
  colapsableDivDME_TACAN:boolean = true;
  colapsableLabelAntennaDiagram:boolean = true;
  colapsableDivAntennaDiagram:boolean = false;
  colapsableLabelVorInformation:boolean = true;
  colapsableDivVorInformation:boolean = true;
  colapsableLabelNDBInformation:boolean = true;
  colapsableDivNDBInformation:boolean = true;
  colapsableLabelVORSpecific:boolean = true;
  colapsableDivVORSpecific:boolean = true;
  flightInpectionResportsActive: boolean = true;
  map:olMap;
  //navaids tabs control
  primaryDataActive:boolean = true;
  sectorizationActive:boolean = false;
  screeningAnglesActive:boolean = false;
  secondaryDataActive:boolean = false;
  associationsActive:boolean  =false;
  notesActive:boolean = false;

 activeVorFlightInspectionReport = true;
 navaidFileSelected: number;
  navaidToSave:NavaidModel = new NavaidModel();

  antennaTypesEnum = AntennaTypes;



  
  public readonly NavaidStatusEnum = NavaidStatus;


  constructor(navaidController : NavaidsService, mapService : MapService, pointsController : PointsService,
    private toolsService : ToolsControlService, private globalSelectionService : GlobalSelectionControlService,
    private confirmationModalService: ModalConfirmationService, private modalService : ModalControlService,
    menuService: MenuManagementService,
    public configurationService: ConfigurationService,
    public tabsService: TabsService,
    private rcsControl : CoordenateService,
    private utilsService: UtilsService,
    private vicentyToolService: VicentyToolControlService,
    public antennaPatternService: SelectAntennaPatternService,
    public projectService: ProjectService
    ) {

    this.navaidController = navaidController;
    this.pointsController = pointsController;
    this.menuController = menuService;
    this.mapService = mapService;
    this.map = this.mapService.getMap('map');
    this.navaidController.selectedNavaid = new NavaidModel();
    // TODO: Move click listener to Service if click event is not necessary to be always running. And remove listener when not necessary anymore
    this.map.on('dblclick', async (evt) => {
      if(navaidController.active && !this.globalSelectionService.isBoxAll() && !this.globalSelectionService.isCircleAll()){
        var coords = toLonLat(evt.coordinate,this.rcsControl.activeRCS.isactive? this.rcsControl.activeRCS.epsg : "EPSG:3857");
        var lat = coords[1];
        var lon = coords[0];
        /*
        var coords2 = fromLonLat(coords)
        this.navaidController.initializeIcaoCodes(evt.coordinate[1], evt.coordinate[0]);
*/
        this.navaidController.selectedNavaid.latitude = lat;
        this.navaidController.selectedNavaid.longitude = lon;
        this.navaidController.selectedNavaid.latLonDms.fromLat(lat);
        this.navaidController.selectedNavaid.latLonDms.fromLon(lon);
        (await this.pointsController.getTerrainElevation(this.navaidController.selectedNavaid.latitude, this.navaidController.selectedNavaid.longitude)).subscribe(
          (data) => {
            this.navaidController.selectedNavaid.elevationTerrainMeters = data;
            this.navaidController.selectedNavaid.elevationTerrainFeet = this.pointsController.convertToFeet(data);

            this.navaidController.selectedNavaid.elevationRelativeTerrainMeters = this.navaidController.selectedNavaid.elevationTerrainMeters + this.navaidController.selectedNavaid.antheightMeters;
            this.navaidController.selectedNavaid.elevationRelativeTerrainFeet = this.navaidController.selectedNavaid.elevationTerrainFeet + this.navaidController.selectedNavaid.antheight;

          }
        );
      }
     });
   }

  ngOnInit(): void {
    /*this.primaryForm = new FormGroup({
      navaidid: new FormControl(this.navaidController.selectedNavaid.navaidid,[Validators.maxLength(5),Validators.required]),
      name: new FormControl(this.navaidController.selectedNavaid.name, [Validators.required]),
      navaidtype: new FormControl(this.navaidController.selectedNavaid.navaidtype),
      latCardinal: new FormControl( this.navaidController.selectedNavaid.latLonDms.latitude.cardinal),
      latDegrees: new FormControl(this.navaidController.selectedNavaid.latLonDms.latitude.degrees),
      latMinutes: new FormControl(this.navaidController.selectedNavaid.latLonDms.latitude.minutes),
      latSeconds : new FormControl(this.navaidController.selectedNavaid.latLonDms.latitude.seconds),
      latitude : new FormControl(this.navaidController.selectedNavaid.latLonDms.latitude),
      lonCardinal: new FormControl(this.navaidController.selectedNavaid.latLonDms.longitude.cardinal),
      lonDegrees: new FormControl(this.navaidController.selectedNavaid.latLonDms.longitude.minutes),
      lonMinutes: new FormControl(this.navaidController.selectedNavaid.latLonDms.longitude.minutes),
      lonSeconds : new FormControl(this.navaidController.selectedNavaid.latLonDms.longitude.seconds),
      longitude : new FormControl(this.navaidController.selectedNavaid.latLonDms.longitude),
      icaocc : new FormControl(this.navaidController.selectedNavaid.icaocc, [Validators.maxLength(2), Validators.required]),
      elevation : new FormControl(this.navaidController.selectedNavaid.elevation),
      elevationMeters : new FormControl(this.navaidController.selectedNavaid.elevationMeters),
      terrainrelativeelevationfeet : new FormControl(this.navaidController.selectedNavaid.elevationRelativeTerrainFeet),
      terrainrelativeelevationmeters : new FormControl(this.navaidController.selectedNavaid.elevationRelativeTerrainMeters),
      antheight : new FormControl(this.navaidController.selectedNavaid.antheight),
      antheightMeters : new FormControl(this.navaidController.selectedNavaid.antheightMeters),
      terrainelevationfeet : new FormControl(this.navaidController.selectedNavaid.elevationTerrainFeet),
      terrainelevationmeters : new FormControl(this.navaidController.selectedNavaid.elevationTerrainMeters),
      doc : new FormControl(this.navaidController.selectedNavaid.doc,[Validators.min(1), Validators.max(300),Validators.required]),
      maxaltitude : new FormControl(this.navaidController.selectedNavaid.maxaltitude),
      maxaltitudeMeters : new FormControl(this.navaidController.selectedNavaid.maxaltitudeMeters),
      infoupdate : new FormControl(this.navaidController.selectedNavaid.infoupdate)
    });*/

    /*this.configurationService.getActiveConfiguration().subscribe( (config : ConfigurationModel) => {
      this.secondaryForm = new FormGroup({
        mtbo : new FormControl(this.navaidController.selectedNavaid.mtbo,[Validators.min(1), Validators.max(100000)]),
        operator : new FormControl(this.navaidController.selectedNavaid.operator),
        infosrce : new FormControl(this.navaidController.selectedNavaid.infosrce),
        infoupdate : new FormControl(this.navaidController.selectedNavaid.infoupdate),
        manufacturer : new FormControl(this.navaidController.selectedNavaid.manufacturer),
        model : new FormControl(this.navaidController.selectedNavaid.model),
        operationalstatus : new FormControl(this.navaidController.selectedNavaid.operationalstatus),
        operationalsince : new FormControl(this.navaidController.selectedNavaid.operationalsince),
        dueforreplacement : new FormControl(this.navaidController.selectedNavaid.dueforreplacement),
        plannedremoval : new FormControl(this.navaidController.selectedNavaid.plannedremoval),
        lastinspection : new FormControl(this.navaidController.selectedNavaid.lastinspection),
        inpectioninterval : new FormControl(this.navaidController.selectedNavaid.fligthinspectioninterval,[Validators.min(0), Validators.max(2.14748365e9)]),
        plannedinspection : new FormControl(this.navaidController.selectedNavaid.plannedinspection),
        dmetacanclass : new FormControl(this.navaidController.selectedNavaid.dmetacanclass),
        meetingpost1989sarps : new FormControl(this.navaidController.selectedNavaid.meetingpost1989sarps),
        vhfTunFreqInput : new FormControl(this.navaidController.selectedNavaid.vhfTunFreqInput),
        uhfDownlinkFreqInput : new FormControl({value:this.navaidController.selectedNavaid.uhfDownlinkFreqInput, disabled: true}),
        uhfUplinkFreqInput : new FormControl({value:this.navaidController.selectedNavaid.uhfUplinkFreqInput, disabled: true}),
        channel : new FormControl(this.navaidController.selectedNavaid.channel),
        bias : new FormControl(this.navaidController.selectedNavaid.bias),
        transmoutpower : new FormControl(this.navaidController.selectedNavaid.transmoutpower),
        cableloss : new FormControl(this.navaidController.selectedNavaid.cableloss),
        declaredeirp : new FormControl(this.navaidController.selectedNavaid.declaredeirp),
        antennatype : new FormControl(this.navaidController.selectedNavaid.antennatype),
        cone : new FormControl(this.navaidController.selectedNavaid.cone,[Validators.min(5), Validators.max(this.configurationService.currentConfiguration.calculation.coneOfSilenceDefa)]),
        arinc424fom : new FormControl(this.navaidController.selectedNavaid.arinc424fom),
        maxload : new FormControl(this.navaidController.selectedNavaid.maxload),
        quiescentsquitterrate : new FormControl(this.navaidController.selectedNavaid.quiescentsquitterrate),
        vortype : new FormControl(this.navaidController.selectedNavaid.vortype),
        vordocmaxrange : new FormControl(this.navaidController.selectedNavaid.vordocmaxrange,[Validators.min(1), Validators.max(500)]),
        vorlatitude : new FormControl(this.navaidController.selectedNavaid.vorlatitude, [Validators.min(-90), Validators.max(90)]),
        vorLatCardinal : new FormControl(this.navaidController.selectedNavaid.vorLatLonDms.latitude.cardinal),
        vorLatDegrees :  new FormControl (this.navaidController.selectedNavaid.vorLatLonDms.latitude.degrees,[Validators.min(0), Validators.max(90)]),
        vorLatMinutes :  new FormControl(this.navaidController.selectedNavaid.vorLatLonDms.latitude.minutes,[Validators.min(0), Validators.max(59)]),
        vorLatSeconds :  new FormControl(this.navaidController.selectedNavaid.vorLatLonDms.latitude.seconds,[Validators.min(0), Validators.max(59.99)]),
        vorLonCardinal :  new FormControl(this.navaidController.selectedNavaid.vorLatLonDms.longitude.cardinal),
        vorLonDegrees :  new FormControl(this.navaidController.selectedNavaid.vorLatLonDms.longitude.degrees,[Validators.min(0), Validators.max(180)]),
        vorLonMinutes :  new FormControl(this.navaidController.selectedNavaid.vorLatLonDms.longitude.minutes,[Validators.min(0), Validators.max(59)]),
        vorLonSeconds :  new FormControl(this.navaidController.selectedNavaid.vorLatLonDms.longitude.seconds,[Validators.min(0), Validators.max(59.99)]),
        vorlongitude : new FormControl(this.navaidController.selectedNavaid.vorlongitude,[Validators.min(-180), Validators.max(180)]),
        ndbfrequency : new FormControl(this.navaidController.selectedNavaid.ndbfrequency, [Validators.min(190), Validators.max(1750)]),
        offsetdist : new FormControl(this.navaidController.selectedNavaid.offsetdist),
        voroperstatus : new FormControl(this.navaidController.selectedNavaid.voroperstatus),
        voroperationalsince : new FormControl(this.navaidController.selectedNavaid.voroperationalsince),
        vordueforreplace : new FormControl(this.navaidController.selectedNavaid.vordueforreplace),
        vorplannedremoval : new FormControl(this.navaidController.selectedNavaid.vorplannedremoval),
        vorlastinsp : new FormControl(this.navaidController.selectedNavaid.vorlastinsp),
        vorinpectioninterval : new FormControl(this.navaidController.selectedNavaid.vorinpectioninterval,[Validators.min(0), Validators.max(2.14748365e9)]),
        vorplannedinspection : new FormControl(this.navaidController.selectedNavaid.vorplannedinspection)
      });*/
  }


  // Getter for 'published', inverse of 'userdefined'
  get published(): boolean {
    return !this.navaidController.selectedNavaid.userdefined;
  }

  // Setter for 'published', also inverses 'userdefined'
  set published(value: boolean) {
    this.navaidController.selectedNavaid.userdefined = !value;
  }

  getAntennaTypeValues(){
    return Object.values(this.antennaTypesEnum);
  }
  checkNavaidFile(i: number){
    this.navaidFileSelected = i;
  }
  remove(){
    if(this.navaidFileSelected == null)
      return;
    this.navaidController.selectedNavaid.navaidFiles.splice(this.navaidFileSelected,1);
    this.navaidFileSelected = null;
  }
  downloadNavaidFile(){
    if(this.navaidFileSelected == null)
      return;
    let navaidFile: NavaidFile = this.navaidController.selectedNavaid.navaidFiles[this.navaidFileSelected];
    const objectUrl: string = URL.createObjectURL(this.utilsService.base64ToBlob(navaidFile.fileData));
    const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
    a.href = objectUrl;
    a.download = navaidFile.fileName;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);

  }

  checkFormValid() {
    return this.navaidController.docValid && this.navaidController.coneValid && this.navaidController.mtboValid
    && this.navaidController.docMaxAltitudeValid && this.navaidController.latitudeValid && this.navaidController.lat_degreesValid
    && this.navaidController.lat_minutesValid && this.navaidController.lat_secondsValid && this.navaidController.longitudeValid
    && this.navaidController.lon_degreesValid && this.navaidController.lon_minutesValid && this.navaidController.lon_secondsValid
    && this.navaidController.vorLatitudeValid && this.navaidController.vorLat_degreesValid && this.navaidController.vorLat_minutesValid
    && this.navaidController.vorLat_secondsValid && this.navaidController.vorLongitudeValid && this.navaidController.vorLon_degreesValid
    && this.navaidController.vorLon_minutesValid && this.navaidController.vorLon_secondsValid && this.navaidController.inpectionIntervalValid
    && this.navaidController.vorInpectionIntervalValid && this.navaidController.vorDocMaxRangeValid && this.navaidController.ndbFrequencyValid;

  }
  activatePrimaryData():void{
    this.primaryDataActive = true;
    this.sectorizationActive = false;
    this.screeningAnglesActive = false;
    this.secondaryDataActive = false;
    this.associationsActive = false;
    this.notesActive = false;
  }

  activateSecondaryData():void{
    this.primaryDataActive = false;
    this.sectorizationActive = false;
    this.screeningAnglesActive = false;
    this.secondaryDataActive = true;
    this.associationsActive = false;
    this.notesActive = false;
  }

  activateAssociations():void{
    this.primaryDataActive = false;
    this.sectorizationActive = false;
    this.screeningAnglesActive = false;
    this.secondaryDataActive = false;
    this.associationsActive = true;
    this.notesActive = false;
  }

  activateNotes():void{
    this.primaryDataActive = false;
    this.sectorizationActive = false;
    this.screeningAnglesActive = false;
    this.secondaryDataActive = false;
    this.associationsActive = false;
    this.notesActive = true;
  }

  activateSectorization():void{
    this.primaryDataActive = false;
    this.sectorizationActive = true;
    this.screeningAnglesActive = false;
    this.secondaryDataActive = false;
    this.associationsActive = false;
    this.notesActive = false;
  }

  activateScreeningAngles():void{
    this.primaryDataActive = false;
    this.sectorizationActive = false;
    this.screeningAnglesActive = true;
    this.secondaryDataActive = false;
    this.associationsActive = false;
    this.notesActive = false;
  }


  colapsableLabelSectorizationsTrigger():void {
    this.colapsableLabelSectorizations = !this.colapsableLabelSectorizations;
    this.colapsableDivSectorizations = !this.colapsableDivSectorizations;
  }

  colapsableLabelGeneralPlanningTrigger():void {
    this.colapsableLabelGeneralPlanning = !this.colapsableLabelGeneralPlanning;
    this.colapsableDivGeneralPlanning = !this.colapsableDivGeneralPlanning;
  }

  colapsableProceduresList():void {
    this.colapsableLabelProceduresList = !this.colapsableLabelProceduresList;
    this.colapsableDivProceduresList = !this.colapsableDivProceduresList;
  }

  colapsableAirspaceBoundariesList():void {
    this.colapsableLabelAirspaceBoundariesList = !this.colapsableLabelAirspaceBoundariesList;
    this.colapsableDivAirspaceBoundariesList = !this.colapsableDivAirspaceBoundariesList;
  }

  colapsableLabelDME_TACANTrigger():void {
    this.colapsableLabelDME_TACAN = !this.colapsableLabelDME_TACAN;
    this.colapsableDivDME_TACAN = !this.colapsableDivDME_TACAN;
  }

  colapsableLabelAntennaDiagramTrigger():void {
    this.colapsableLabelAntennaDiagram = !this.colapsableLabelAntennaDiagram;
    this.colapsableDivAntennaDiagram = !this.colapsableDivAntennaDiagram;
  }

  colapsableLabelVorInformationTrigger():void {
    this.colapsableLabelVorInformation = !this.colapsableLabelVorInformation;
    this.colapsableDivVorInformation = !this.colapsableDivVorInformation;
  }

  colapsableLabelNDBInformationTrigger():void {
    this.colapsableLabelNDBInformation = !this.colapsableLabelNDBInformation;
    this.colapsableDivNDBInformation = !this.colapsableDivNDBInformation;
  }


  colapsableLabelVORSpecificTrigger():void {
    this.colapsableLabelVORSpecific = !this.colapsableLabelVORSpecific;
    this.colapsableDivVORSpecific = !this.colapsableDivVORSpecific;
  }

  cancelNavaid():void{
    this.navaidController.active = !this.navaidController.active;
    this.navaidController.selectedNavaid = new NavaidModel();
    this.navaidController.selectedNavaid.cone = 50.0;
    this.toolsService.navigationOnTop = false;
  }



  async saveNavaidValidation(): Promise<void>{
    if (!(await this.configurationService.operationAllowedByCalculationManager())) {
      return;
    }
    this.navaidToSave = this.navaidController.getNavaidPayload(this.navaidController.selectedNavaid);
    this.navaidToSave.notupdate = String(!this.navaidController.navaidUpdate);
    if(this.navaidController.editMode){
      if (!this.navaidController.selectedNavaidUserDefinedStatus){
        this.navaidToSave.userdefined = true;
        this.confirmationModalService.showMesssageConfirmationModal("Save Navaid", "You are editing a published NavAid, do you wish to continue and save the changes?", "OK", "Cancel", () => this.saveNavaid());
      }else {
        this.saveNavaid();
      }
    }else if(!this.navaidController.editMode) {
      this.confirmationModalService.showMesssageConfirmationModal("Save Navaid", "Changing the Navaid Id, Type or ICAO code will transform this Navaid into a different Navaid and the references and relations to it on other data sources may be lost. Do you wish to continue?", "OK", "Cancel", () => this.saveNavaid());
    }
  }

  getSectorizationMessage() : boolean {
    let toReturn : boolean = false;

    if(this.navaidController.selectedNavaid.sectorizations.length > 0){
      toReturn = true;
    }

    return toReturn;
  }

  getScreeningAnglesMessage() : boolean {
    let toReturn : boolean = false;

    if(this.navaidController.selectedNavaid != null && this.navaidController.selectedNavaid.actualScreeningAngle.length > 0){
      toReturn = true;
    }

    return toReturn;
  }
   degreesToRadians(Value) {
      return Value * Math.PI / 180;
  }

  navaidDuplicateCheck(navaid: NavaidModel) :boolean {
    let  navaids : NavaidModel[] = this.pointsController.getAllNavaidsFromLayers();
    for(var potentialDuplicate of navaids){
      if(NavaidModel.navaidsAreDuplicates(potentialDuplicate,navaid)){
        return true;
      }
    }
    return false;
  }
  async saveNavaid() {
    let closeTab: boolean;
    if(!this.navaidController.editMode){
        if(this.navaidDuplicateCheck(this.navaidToSave)){
          this.modalService.showMesssageModal('Error Creating Navaid:','Duplicate Navaid' );
          return;
        }
        closeTab = this.pointsController.createNavaid(this.navaidToSave)
    }
    else{
      closeTab = await this.pointsController.saveNavaid(this.navaidToSave);
    }
    if(closeTab){
      this.tabsService.closeTab();
    }
    this.navaidController.selectedNavaid.sectorizations.forEach(element => {
      if(element.istodelete){
        this.navaidController.selectedNavaid.removeSectorization(element);
      }
      element.isselected = false;
    });

    this.navaidController.selectedNavaid.actualScreeningAngle.forEach(element => {
      if(element.istodelete){
        this.navaidController.selectedNavaid.removeAngle(element);
      }
      element.isselected = false;
    });

  }

  addSectorizationTrigger():void {
    this.navaidController.activeSectorizations = !this.navaidController.activeSectorizations;
  }

  deleteSectorizations():void {
    this.navaidController.selectedNavaid.sectorizations.forEach(element => {
      if(element.isselected){
        element.istodelete = true;
      }
    });
  }

  displaySectorizations(): void{
    this.navaidController.getSectorizationDisplay();
  }

  addMinimumScreeningAngleTrigger():void {
    this.navaidController.activeAngles = !this.navaidController.activeAngles;
  }

  deleteAngle():void {
    this.navaidController.selectedNavaid.actualScreeningAngle.forEach(element => {
      if(element.isselected){
        element.istodelete = true;
      }
    });
  }

  colapsableLabelActualScreeningActualTrigger():void {
    this.colapsableLabelActualScreeningAngle = !this.colapsableLabelActualScreeningAngle;
    this.colapsableDivActualScreeningAngle = !this.colapsableDivActualScreeningAngle;
  }



  addProcedureFromMap() : void {
    let features : Feature[] = this.pointsController.getSelectedFeatures().filter(feat => feat.get("featureType") == FeatureType.Procedure);
    features.forEach( feat => {
      let procedure : ProcedureModel = this.pointsController.transformFeatureInProcedure(feat);
      const found = this.navaidController.selectedNavaid.associatedProcedures.some(el => el.id == procedure.id);
      if(!found){
        this.navaidController.selectedNavaid.associatedProcedures.push(procedure);
      }
    });
  }

  addAirspaceFromMap() : void {
    let features : Feature[] = this.pointsController.getSelectedFeatures().filter(feat => feat.get("featureType") == FeatureType.AirSpaceBoundary);
    features.forEach( feat => {
      let airspace : AirSpaceBoundaryModel = this.pointsController.transformFeatureInAirspaceBoundary(feat);
      const found = this.navaidController.selectedNavaid.associatedAirspaceBoundaries.some(el => el.id == airspace.id);
      if(!found){
        this.navaidController.selectedNavaid.associatedAirspaceBoundaries.push(airspace);
      }
    });
  }

  selectNavaidProcedure(procedure : ProcedureModel) : void {
    this.navaidController.selectedNavaid.associatedProcedures.forEach( elm => {
      if(procedure.id == elm.id){
        elm.isselected = true;
      }else {
        elm.isselected = false;
      }
    });
  }

  selectNavaidAirpsace(airspace : AirSpaceBoundaryModel) : void {
    this.navaidController.selectedNavaid.associatedAirspaceBoundaries.forEach( elm => {
      if(airspace.id == elm.id){
        elm.isselected = true;
      }else {
        elm.isselected = false;
      }
    });
  }

  deleteSelectedProcedureFromList(){
    this.navaidController.selectedNavaid.associatedProcedures.forEach(function(item, index, object) {
      if (item.isselected) {
        object.splice(index, 1);
      }
    });
  }

  deleteSelectedAirspaceFromList(){
    this.navaidController.selectedNavaid.associatedAirspaceBoundaries.forEach(function(item, index, object) {
      if (item.isselected) {
        object.splice(index, 1);
      }
    });
  }

  selectProceduresRows() : void{
    this.navaidController.selectedNavaid.associatedProcedures.forEach( elm => {
      if(elm.isselected){
        let feat : Feature = this.pointsController.getProcedureFeatureFromLayers(elm.id.toString());
        let layer : VectorLayerDMTR = this.pointsController.proceduresLayers.childLayers[0].layers.find((element) => element.id === elm.proceduretype.toLowerCase()).olLayer;
        this.globalSelectionService.selectProcedureOnMap(feat, layer);
      }
    });
  }

  selectAirpsaceRows() : void{
    this.navaidController.selectedNavaid.associatedAirspaceBoundaries.forEach( elm => {
      if(elm.isselected){
        let feat : Feature = this.pointsController.getAirspaceBoundaryFeatureFromLayers(elm.id.toString());
        let layer : VectorLayerDMTR = this.pointsController.proceduresLayers.childLayers[0].layers[0].olLayer;
        this.globalSelectionService.selectAirspaceBoundarynMap(feat, layer);
      }
    });
  }

}
